import { render, staticRenderFns } from "./ChannelSettings.html?vue&type=template&id=05b742fc&scoped=true&"
import script from "./ChannelSettings.js?vue&type=script&lang=js&"
export * from "./ChannelSettings.js?vue&type=script&lang=js&"
import style0 from "./ChannelSettings.scss?vue&type=style&index=0&id=05b742fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b742fc",
  null
  
)

export default component.exports